module.exports = __webpack_public_path__ + "img/respecth-mech-download.47a6f214.png";